<template>
  <v-navigation-drawer
    id="appDrawer"
    class="admin-sidebar"
    :mini-variant.sync="mini"
    fixed
    :dark="$vuetify.dark"
    app
    v-model="sidebarExpanded"
    width="220"
    >
    <v-app-bar color="white" class="hpo_color d-flex align-center">
      <div class="admin-sidebar-logo-text">CSIMEX</div>
    </v-app-bar>
    <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
      <v-list dense expand>
        <template v-for="(item, i) in menus">
          <template v-if="item.roleId & userRole && (item.hideRole == null || item.hideRole.indexOf(userRoleType) === -1)">
            <!--group with subitems-->
            <v-list-group v-if="item.items && !item.hideSub" :key="`group-${item.name}`" :group="item.group" :prepend-icon="item.icon" no-action="no-action" class="admin-sidebar-group">
                <v-list-item slot="activator" ripple="ripple">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.titleKey ? $t('routes.' + item.titleKey) : item.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <template v-for="(subItem, i) in item.items">
                  <!--sub group-->
                  <v-list-group v-if="subItem.items" :key="subItem.name" :group="subItem.group" sub-group="sub-group" class="admin-sidebar-group">
                    <v-list-item slot="activator" ripple="ripple">
                      <v-list-item-content>
                        <v-list-item-title>{{ subItem.titleKey ? $t('routes.' + subItem.titleKey) : subItem.title }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-for="(grand, i) in subItem.children" :key="i" :to="genChildTarget(item, grand)" :href="grand.href" ripple="ripple">
                      <v-list-item-content>
                        <v-list-item-title>{{ grand.titleKey ? $t('routes.' + grand.titleKey) : grand.title }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                  <!--child item-->
                  <v-list-item v-else-if="userRole & item.roleId" :key="i" :to="genChildTarget(item, subItem)" :href="subItem.href" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple">
                    <v-list-item-content>
                      <v-list-item-title><span>{{ subItem.titleKey ? $t('routes.' + subItem.titleKey) : subItem.title }}</span></v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="subItem.action">
                      <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </template>
            </v-list-group>
            <v-subheader v-else-if="item.header" :key="`header-${i}`">{{ item.header }}</v-subheader>
            <v-divider v-else-if="item.divider" :key="`divider-${i}`"></v-divider>
            <!--top-level link-->
            <v-list-item v-else :to="!item.href ? { name: item.name } : null" :href="item.href" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="item.name">
              <v-list-item-action v-if="item.icon">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  <v-badge color="orange" :content="getOrderNumber(item.name)" v-if="item.badge && getOrderNumber(item.name)">
                    {{ item.titleKey ? $t('routes.' + item.titleKey) : item.title }}
                  </v-badge>
                  <span v-else>{{ item.titleKey ? $t('routes.' + item.titleKey) : item.title }}</span>
                  </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action v-if="item.subAction">
                <v-icon class="success--text">{{ item.subAction }}</v-icon>
              </v-list-item-action>
            </v-list-item>
        </template>
      </template>
      </v-list>
      <div class="extend-menu"></div>
    </vue-perfect-scrollbar>
  </v-navigation-drawer>
</template>
<script>
import { getMenusByRole } from '@/api/menu';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import configs from "@/configs";
export default {
  name: 'app-drawer',
  components: {
    VuePerfectScrollbar,
  },
  props: {
    expanded: {
      type: Boolean,
      default: true
    },
  },
  data: () => ({
    mini: false,
    scrollSettings: {
      maxScrollbarLength: 160,
      wheelPropagation: true
    }    
  }),
  computed: {
    sidebarExpanded: {
      get() {
        return this.$store.state.commons.sidebarExpanded;
      },
      set(val) {
        this.$store.commit("commons/setSidebarExpanded", { expanded: val });
      }
    },
    computeGroupActive () {
      return true;
    },
    computeLogo () {
      return '/static/logo.png';
    },
    userRole() {
      const role_type = _.find(configs.ROLES, {'value': this.$store.state.authentication.user.roleid})
      return role_type ? role_type.modules : 0;
    },
    userRoleId() {
      return this.$store.state.authentication.user.roleid;
    },
    userRoleType() {
      return this.userRoleId;
    },
    menus() {
      return getMenusByRole(this.userRoleId);
    },
    sideToolbarColor () {
      return this.$vuetify.options.extra.sideNav;
    }
  },
  methods: {
    genChildTarget (item, subItem) {
      if (subItem.href) return;
      if (subItem.component) {
        return {
          name: subItem.component,
        };
      }
      return { name: `${item.group}/${(subItem.name)}` };
    },
    checkAuth() {
      if(localStorage.getItem('jwt') == null) {
        setTimeout(this.$router.replace({ path: '/login' }),100);
      }
    },
  },
  created() {
    this.checkAuth();
    this.timer = setInterval(this.checkAuth, 1000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>


<style lang="stylus">
#appDrawer
  overflow: hidden
  .drawer-menu--scroll
    height: calc(100vh - 48px)
    overflow: auto

</style>
